/* eslint-disable no-unused-vars */
import get from "lodash/get";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";
import canUseDom from "../../../utils/can-use-dom";

const PBThemeSetting = props => {
  const supportedPages = {
    "home-page": "home",
    "section-page": "section",
    "collection-page": "section",
    "tag-page": "tag",
    "author-page": "author",
    "pagebuilder-section-preview-page": "section",
    "pagebuilder-collection-preview-page": "section",
    "pagebuilder-story-preview-page": "story",
    "authors-page": "authors",
    "": ""
  };

  const pageBgColor = get(props.pbConfig, [supportedPages[props.pageType], "pageSetting", "bgColor"], "#fff");

  useEffect(() => {
    if (canUseDom) {
      document.getElementsByTagName("body")[0].style.backgroundColor = pageBgColor;
    }
    return function cleanup() {
      if (canUseDom) {
        document.getElementsByTagName("body")[0].style.backgroundColor = "";
      }
    };
  });
  return null;
};

PBThemeSetting.propTypes = {
  pageTypes: PropTypes.string
};

const mapStatetoProps = state => {
  return {
    pbConfig: get(state, ["qt", "config", "pagebuilder-config"], {}),
    pageType: get(state, ["qt", "pageType"], "")
  };
};

export const PBThemeSettings = connect(mapStatetoProps)(PBThemeSetting);
